// The colour painted behind the (transparent) Android status bar. Screens sit below the bar, so a
// screen whose top isn't the page ground (the sign-in frame's scene) claims the bar while it is
// shown and gives it back when it goes. Null = the page ground.
import { useEffect, useSyncExternalStore } from "react";

let colour: string | null = null;
const listeners = new Set<() => void>();

function set(next: string | null) {
  colour = next;
  for (const l of listeners) l();
}

export function useStatusBarColour(): string | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => colour,
    () => colour,
  );
}

/** Paints the status bar area `value` while the calling screen is mounted. */
export function useClaimStatusBar(value: string | null): void {
  useEffect(() => {
    if (value === null) return;
    set(value);
    return () => {
      if (colour === value) set(null);
    };
  }, [value]);
}
